import _ from 'lodash';
import { selectMetricsModalOption } from 'modals/modal-options-factory';
import {
  DefinitionLevels,
  SettingValues,
  metricNames
} from '@linearb/linjs-common';
import { getFormattedAndCalculatedV3Data } from '../groupDashboard.service';
import { getRedirectParamsByMetric } from 'common/constants/metrics';
import history from 'common/RouterHistory';
import QueryString from 'query-string';

export const MIN_METRICS_TO_SELECT = 2;
export const MAX_METRICS_TO_SELECT = 4;
export const METRICS_MODAL_INSTRUCTIONS =
  'Please select between 2 to 4 metrics.';
export const METRICS_NOT_CLICKABLE = [
  metricNames.COMMIT_CODE_CHANGES,
  metricNames.COMMIT_COUNT,
  metricNames.PR_NEW,
  metricNames.REVIEWS,
  metricNames.DONE_BRANCHES,
  metricNames.ACTIVE_DAYS,
  metricNames.ACTIVE_BRANCHES
];

export const getClickableMetrics = () => METRICS_NOT_CLICKABLE;

export const getMetricsToAddToDashboard = (
  metricNames,
  availableMetricsWidgets
) => {
  return availableMetricsWidgets
    .filter(metric => [...metricNames].includes(metric.name))
    .map(metric => _.get(metric, 'metrics[0].name'));
};

export const onDone = async (
  selectedMetricsNames,
  toggleModal,
  availableMetricsWidgets,
  setWidgetsMetricsNames,
  updateSetting,
  teamId
) => {
  const metricsToAddToDashboard = getMetricsToAddToDashboard(
    selectedMetricsNames,
    availableMetricsWidgets
  );

  try {
    await updateSetting(
      SettingValues.GROUP_DASHBOARD_METRICS_WIDGETS,
      metricsToAddToDashboard,
      DefinitionLevels.TEAM,
      teamId,
      true
    );

    setWidgetsMetricsNames(metricsToAddToDashboard);
  } catch (e) {}

  toggleModal();
};

/* istanbul ignore next */
export const handleEditMetricsClick = (
  toggleModal,
  availableMetricsWidgets,
  setWidgetsMetricsNames,
  initialState,
  updateSetting,
  selectedGroupId,
  minMetricsToSelect,
  maxMetricsToSelect,
  modalInstructions
) => {
  toggleModal(
    selectMetricsModalOption({
      initialState,
      metrics: availableMetricsWidgets,
      onDone: selectedMetricsNames =>
        onDone(
          selectedMetricsNames,
          toggleModal,
          availableMetricsWidgets,
          setWidgetsMetricsNames,
          updateSetting,
          selectedGroupId
        ),
      isDisableBtn: selectedMetrics =>
        selectedMetrics.size < minMetricsToSelect ||
        selectedMetrics.size > maxMetricsToSelect,
      shouldDisableSelection: selectedMetrics =>
        selectedMetrics.size === maxMetricsToSelect,
      instructions: modalInstructions
    })
  );
};

export const getWidgetsTitlesInitialState = (
  availableMetricsWidgets,
  widgetsMetricsNames
) => {
  return availableMetricsWidgets
    .filter(widget =>
      widgetsMetricsNames.includes(_.get(widget, 'metrics[0].name'))
    )
    .map(widget => _.get(widget, 'name'));
};

export const getTrendLineDataMappedPerMericName = (
  metricName,
  data,
  availableMetricsWidgets = []
) => {
  const getCalcData = data => {
    const { V3DataCalculated, formattedV3Data } =
      getFormattedAndCalculatedV3Data(
        data,
        [metricName],
        availableMetricsWidgets,
        [data]
      );
    const calcValue = V3DataCalculated[metricName];
    const formattedValue = formattedV3Data[metricName];
    return { calcValue, formattedValue };
  };

  return data.map(item => {
    const { calcValue, formattedValue } = getCalcData(item);
    const data =
      _.isNull(item[metricName]) || item[metricName] === undefined
        ? 0
        : calcValue;
    const { before, after } = item;
    const point = { category: { after, before } };
    return { data, displayValue: data ? formattedValue : 0, point };
  });
};

export const onDotClick = (
  payload,
  metricName,
  selectedGroupId,
  getSettingOrDefinitionValue
) => {
  const point = payload?.payload?.point || {};

  const pointParams = getRedirectParamsByMetric(true, true)({ metricName });
  const redirectParams = pointParams(point);

  if (!redirectParams) {
    return;
  }

  const qsParams = {
    ...redirectParams.qs,
    teams: selectedGroupId
  };

  const qs = _.omitBy(qsParams, _.isNil); // remove all undefined/null props

  history.push({
    pathname: redirectParams.path,
    search: QueryString.stringify(qs),
    state: _.get(redirectParams, 'state', {})
  });
};
